// @flow

import type { ComponentType } from 'react';
import { ACFCheckboxField } from './checkbox';
import { ACFRadioField } from './radio';
import { ACFEmailField } from './email';
import { ACFNumberField } from './number';
import { ACFSelectField } from './select';
import { ACFPhoneField } from './phone';
import { ACFTextField } from './text';
import { ACFTextarea } from './textarea';
import { ACFDateField } from './date';
import { ACFWebPower } from './webpower';
import { ACFReferrer } from './referrer';
import { ACFConfiguration } from './configuration';
import ACFDivider from './divider';
import ACFEndDivider from './end-divider';

type Mapping = {
  select: ComponentType<*>,
  radio: ComponentType<*>,
  checkbox: ComponentType<*>,
  text: ComponentType<*>,
  number: ComponentType<*>,
  phone: ComponentType<*>,
  email: ComponentType<*>,
  date: ComponentType<*>,
  webpowercampaignid: ComponentType<*>,
  webpowermailid: ComponentType<*>,
  webpowerlanguage: ComponentType<*>,
  webpowergroupname: ComponentType<*>,
  carconfiguration: ComponentType<*>,
  divider: ComponentType<*>,
  end_divider: ComponentType<*>,
  referrer: ComponentType<*>,
};

const mapping: Mapping = {
  select: ACFSelectField,
  radio: ACFRadioField,
  checkbox: ACFCheckboxField,
  text: ACFTextField,
  number: ACFNumberField,
  phone: ACFPhoneField,
  email: ACFEmailField,
  textarea: ACFTextarea,
  date: ACFDateField,
  webpowercampaignid: ACFWebPower,
  webpowermailid: ACFWebPower,
  webpowerlanguage: ACFWebPower,
  webpowergroupname: ACFWebPower,
  carconfiguration: ACFConfiguration,
  divider: ACFDivider,
  end_divider: ACFEndDivider,
  referrer: ACFReferrer,
};

export default mapping;
